/* eslint-disable camelcase,no-undef */
import { fetchPosts, truncate, isMobile, containClass, resetAlphabet } from '../utilities/_utilities';

(function() {
    // eslint-disable-next-line no-undef
    const nextNonce = CPT_Ajax.nextNonce;
    // eslint-disable-next-line no-undef
    const ajaxUrl = CPT_Ajax.ajaxurl;

    // Get the content area of CPT Page Teamplete.
    const cptContent = document.getElementById('cpt-content');
    // Get the current page Post Type from data attribute.
    const postType = cptContent.getAttribute('data-post-type');
    // Get all letters from alphabet filter.
    const alphabet = document.querySelector('.alphabet-filter__letters');
    // eslint-disable-next-line no-unused-vars
    let currentPageTitle = '';

    const ajax = {
        action: 'cpt-filter',
        ajaxUrl,
        nextNonce,
    };

    /* =============================================================================
    Alphabet Filter
    =============================================================================== */

    const prevLetterBtn = document.getElementById('prev-letter');
    const nextLetterBtn = document.getElementById('next-letter');
    const letters       = document.querySelectorAll('.alphabet-filter__letter');

    let currentItemIndex = null;

    if (alphabet) {
        alphabet.addEventListener(
            'click',
            function(event) {
                // which letter is clicked.
                const letter = event.target.getAttribute('data-letter');
                //  the letter position index in existing list.
                const letterIndex = event.target.getAttribute('data-index');
                if (letters[currentItemIndex]) {
                    letters[currentItemIndex].classList.remove('active');
                }
                // Update current index.
                currentItemIndex = parseInt(letterIndex);
                letters[letterIndex].classList.add('active');
                const options = { letter };
                fetchPosts(ajax, cptContent, postType, options);
            },
            false
        );
    }

    if (prevLetterBtn) {
        prevLetterBtn.addEventListener('click', function() {
            if (typeof currentItemIndex === 'number' && currentItemIndex > 0) {
                letters[currentItemIndex].classList.remove('active');
                letters[currentItemIndex - 1].classList.add('active');
                const options = {
                    letter: letters[currentItemIndex - 1].dataset.letter,
                };
                fetchPosts(ajax, cptContent, postType, options);
                currentItemIndex--;
            }
        });
    }

    if (nextLetterBtn) {
        nextLetterBtn.addEventListener('click', function() {
            if (typeof currentItemIndex === 'number') {
                if (currentItemIndex < parseInt(letters.length) - 1) {
                    currentItemIndex++;
                    letters[currentItemIndex - 1].classList.remove('active');
                    letters[currentItemIndex].classList.add('active');
                    const options = {
                        letter: letters[currentItemIndex].dataset.letter,
                    };
                    fetchPosts(ajax, cptContent, postType, options);
                }
            } else {
                const options = { letter: letters[0].dataset.letter };
                // setCurrentFilter(letters[0].dataset.letter, 'letter');
                fetchPosts(ajax, cptContent, postType, options);
                letters[0].classList.add('active');
                currentItemIndex = 0;
            }
        });
    }

    /* =============================================================================
    Search Form Submit Event
    =============================================================================== */
    const cptSearchForm = document.getElementById('custom-search-form');

    if (cptSearchForm) {
        cptSearchForm.addEventListener('submit', event => {
            event.preventDefault();
            resetAlphabet('alphabet-filter__letter');
            const serhTerm = document.getElementById('custom-search-input').value;
            // setCurrentFilter(serhTerm, 's');
            if (isMobile()) {
                fetchPosts(ajax, cptContent, postType, { s: serhTerm }, adjustMobileFilter);
            } else {
                fetchPosts(ajax, cptContent, postType, { s: serhTerm });
            }
        });
    }

    /* =============================================================================
    Dropdown Custom Category filter for CPT
    =============================================================================== */
    const cptCatFilter = document.getElementById('cpt-cat-filter');

    if (cptCatFilter) {
        cptCatFilter.addEventListener('change', event => {
            resetAlphabet('alphabet-filter__letter');
            // setCurrentFilter(event.target.value, 'cpt_cat');
            if (isMobile()) {
                fetchPosts(ajax, cptContent, postType, {
                    cpt_cat: event.target.value,
                }, adjustMobileFilter);
            } else {
                fetchPosts(ajax, cptContent, postType, {
                    cpt_cat: event.target.value,
                });
            }
        });
    }

    /* =============================================================================
    Resource and Club mobile filter
    =============================================================================== */
    const searchFilter = document.getElementById('cpt-mobile-search-filter');
    const searchAlphabet = document.getElementById('cpt-mobile-alphabet-filter');
    const catMobileFilter = document.getElementById('cpt-mobile-cat-filter');
    const cptAlphabetFilter = document.getElementById('rs-page-cpt__filter');
    const customFilter = document.querySelector('.custom-filter');

    if (searchFilter) {
        searchFilter.addEventListener('click', function() {
            searchAlphabet && searchAlphabet.setAttribute('disabled', '');
            catMobileFilter && catMobileFilter.setAttribute('disabled', '');

            // Toggle Search Form
            if (containClass(cptSearchForm, 'custom-search-form--active')) {
                cptSearchForm.classList.remove('custom-search-form--active');
                searchAlphabet && searchAlphabet.removeAttribute('disabled');
                catMobileFilter && catMobileFilter.removeAttribute('disabled');
            } else {
                cptSearchForm.classList.add('custom-search-form--active');
            }
        });
    }

    searchAlphabet && searchAlphabet.addEventListener('click', noneSearchFilter);
    catMobileFilter && catMobileFilter.addEventListener('click', noneSearchFilter);
    /**
     * To handle mobile filter
     */
    function noneSearchFilter() {
        searchFilter.setAttribute('disabled', '');

        // Toggle Alphabet Filter
        if (containClass(customFilter, 'custom-filter--active')) {
            customFilter.classList.remove('custom-filter--active');
            searchFilter.removeAttribute('disabled');
        } else {
            // eslint-disable-next-line no-unused-expressions
            containClass(cptSearchForm, 'custom-search-form--active') ? cptSearchForm.classList.remove('custom-search-form--active') : null;
            customFilter.classList.add('custom-filter--active');
        }
    }

    /**
     * Adjust mobile search filter header.
     *
     * @param {String} searchValue
     * @param {String} type
     */
    const adjustMobileFilter = (searchValue, type) => {
        const cptMobileRow = document.querySelector('.cpt-mobile-row');

        if (cptMobileRow) {
            // Update Page Title with current search term.
            const mobileTitle = document.querySelector('.rs-heading--mobile');

            // Create and Insert Clear Search button.
            const newNode = document.createElement('button');
            newNode.id = 'clear-search';
            newNode.classList.add('clear-search');
            newNode.setAttribute('style', 'margin-bottom: 24px');

            if (type === 'search') {
                newNode.innerHTML = `
                    <span class="icon-Undo_Icon"></span>
                    <span class="clear-search__text">Clear Search</span>
                `;
            } else if (type === 'letter' || type === 'cpt_cat') {
                newNode.innerHTML = `
                    <span class="icon-Undo_Icon"></span>
                    <span class="clear-search__text">Clear Filter</span>
                `;
            }

            // Clear filter or search button.
            newNode.addEventListener('click', function() {
                fetchPosts(ajax, cptContent, postType);
                this.remove();
                if (type === 'search') {
                    mobileTitle.innerText = currentPageTitle;
                    document.getElementById('custom-search-input').value = '';
                    // eslint-disable-next-line no-unused-expressions
                    searchAlphabet ? searchAlphabet.removeAttribute('disabled') : null;
                    // eslint-disable-next-line no-unused-expressions
                    containClass(cptAlphabetFilter, 'rs-page-cpt__filter-hide') ? cptAlphabetFilter.classList.remove('rs-page-cpt__filter-hide') : null;
                } else if (type === 'letter' || type === 'cpt_cat') {
                    // Enable search filter button
                    searchFilter.removeAttribute('disabled');

                    // Reset CPT Cat Select
                    cptCatFilter.selectedIndex = 0;
                    customFilter.classList.remove('custom-filter--active');

                    // Remove hide class
                    document.querySelector('.custom-filter').classList.remove('hide');
                    document.querySelector('.alphabet-filter').classList.remove('hide');
                }
            });
            const parentDiv = cptSearchForm.parentNode;
            parentDiv.insertBefore(newNode, cptSearchForm);

            if (type === 'search') {
                currentPageTitle = mobileTitle.innerText;
                mobileTitle.innerText = truncate(searchValue, 15);
                // Hide Search Form.
                cptSearchForm.classList.remove('custom-search-form--active');
            } else if (type === 'cpt_cat') {
                customFilter.classList.remove('custom-filter--active');
            }
        }
    };
})(CPT_Ajax);
